<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="objetComplementaire?.classPrincipale"
  [label]="step4.getclassprincipale" [type]="'autocompleteWithStar'" [autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
  [rule]="'pattern_17'" [errorMessage]="{'pattern' : 'ctr_1113'}" [name]="getUid() + '_SepAtt_classPrincipale'"
  [preferenceType] = "typeCpv"
  (preferenceSelected)="chargeDonneePreference($event)">
</app-form-input>
